const ar = {
  home: {
    biometric_label: "التحقق من الهوية البيومترية",
    title: "بحث عكسي عن الوجوه بكل سهولة",
    description:
      "قم بتحميل صورة شخصية عالية الدقة للمقارنة مع الأرشيفات الرقمية العالمية باستخدام تقنية المطابقة العصبية المتقدمة.",
    drag_drop: "اسحب وأفلت صورتك",
    file_formats: "يدعم RAW وJPEG وPNG (الحد الأقصى 15MB)",
    select_file: "اختر ملفاً من النظام",
    initiate_scan: "بدء الفحص الجنائي",
    upload_hint: "يرجى تحميل صورة للمتابعة",
    uploading: "جاري التحميل",
    searching: "جاري الفحص",
    result_title: "النتائج",
    drop_here: "أفلت الصورة هنا...",
    billion_faces: "قارن مع أكثر من مليار وجه على الإنترنت",
    login_to_search: "تسجيل الدخول للبحث",
    login_required: "قم بتسجيل الدخول أو إنشاء حساب لاستخدام هذا التطبيق",
    not_enough_tokens: "رصيد غير كافٍ",
    please_wait: "يرجى الانتظار بضع دقائق",
    leave_confirmation: "هناك عملية جارية. هل أنت متأكد من أنك تريد المغادرة؟",
  },
  sources: {
    section_title: "المصادر التي نبحث فيها",
    social_media: {
      name: "وسائل التواصل الاجتماعي",
      description:
        "مقارنات عبر الشبكات الاجتماعية الكبرى والملفات الشخصية العامة.",
    },
    web: {
      name: "الويب",
      description: "يفحص الويب المفتوح بحثاً عن بيانات الوجوه المتاحة للعموم.",
    },
    scammers: {
      name: "المحتالون",
      description: "مطابقة مع قواعد بيانات هويات المحتالين المعروفين.",
    },
    sexual_offenders: {
      name: "مرتكبو الجرائم الجنسية",
      description: "مقارنات مع سجلات المجرمين الجنسيين المسجلين العامة.",
    },
    videos: {
      name: "الفيديوهات",
      description: "استخراج الوجوه ومطابقتها من منصات الفيديو العامة.",
    },
    police_photos: {
      name: "صور الشرطة",
      description: "مقارنة مع قواعد بيانات السجلات الشرطية المتاحة للعموم.",
    },
    news_and_blogs: {
      name: "الأخبار والمدونات",
      description: "البحث في أرشيفات الأخبار والمحتوى التحريري والمدونات.",
    },
  },
  header: {
    scan: "فحص",
    history: "السجل",
    pricing: "الأسعار",
    account: "الحساب",
    logout: "تسجيل الخروج",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. جميع الحقوق محفوظة. التحقق الدقيق من الهوية.",
    privacy: "سياسة الخصوصية",
    terms: "شروط الخدمة",
    docs: "الوثائق",
    support: "الدعم",
  },
  common: {
    loading: "جاري التحميل...",
    error: "خطأ",
    cancel: "إلغاء",
    back: "رجوع",
  },
  errors: {
    upload_failed: "فشل التحميل. يرجى المحاولة مرة أخرى.",
    not_enough_tokens: "ليس لديك رصيد كافٍ لإجراء هذا البحث.",
  },
  login: {
    disclaimer:
      "تحتاج إلى حساب لاستخدام هذا التطبيق. لا نرسل بريداً عشوائياً ولا نشارك بريدك الإلكتروني. نقترح تسجيل الدخول باستخدام Apple للحفاظ على خصوصيتك.",
  },
  results: {
    input_source: "مصدر الإدخال",
    match_thumbnail: "صورة مصغّرة للتطابق",
    extraction_id: "رقم الاستخراج",
    scan_analysis: "تحليل المسح",
    scan_description:
      "اكتملت عملية البحث العكسي البيومتري. تم العثور على %{count} تطابقات محتملة في السجلات العامة والفهارس الاجتماعية.",
    col_identity_map: "خريطة الهوية",
    col_verification_path: "مسار التحقق",
    col_bio_match_score: "درجة التطابق الحيوي",
    col_action: "الإجراء",
    export_pdf: "تصدير PDF",
    exporting: "جارٍ الإنشاء...",
    verified: "موثق",
    details: "التفاصيل",
    details_tooltip: "تشغيل مقارنة الوجه الدقيقة",
    details_loading: "جارٍ المقارنة...",
    copied: "تم النسخ!",
    copy_url: "نسخ الرابط",
    displaying: "عرض %{count} من أصل %{total} اكتشاف",
  },
};

export default ar;
